import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AuthApiError, OktaAuth } from '@okta/okta-auth-js';
import {
  SupportService,
  ApiResponse,
} from 'apps/app-cic-ciam/src/services/support.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import {
  ClearEnrollResponses,
  ClearEverything,
  EmailEnrollResponse,
  SetLanguage,
  SetTempUserId,
  SmsEnrollResponse,
} from '../../app.actions';
import { STATE_TOKEN, StateModel } from '../../app.states';
import { FormForgotPasswordComponent } from '../../widgets/form-forgot-password/form-forgot-password.component';
import { SelfFactorService } from 'apps/app-cic-ciam/src/services/selffactor.service';

const DEFAULT_ORIGINAL_URI = window.location.origin;

@Component({
  selector: 'digitsolu-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  user: any;
  credential = new EventEmitter<{
    account?: string | null;
    validateFactor?: string | null;
  }>();
  formValues?: {
    account?: string | null;
    validateFactor?: string | null;
  };

  state: string = ''; //=WVNGL3grSERUdFJTVFNibFBsWG91cUZzMkxaUEgxMDBoczJncGlzWmdCUDI5Wkk2Nmx0bmM3end4YVJremtsUA&
  nonce: string = ''; //=tphLFY7GlJssurM4nh4s30rzhAMfciCk&
  code_challenge: string = ''; //=SDr1LUqoRgPsTxe336MVhzrRjhAGcWjnaj4W1bSw5Ew&
  code_challenge_method: string = ''; //=S256&
  client_id: string = ''; //=0oa4cd4j2gVdXd0Ac697&
  redirect_uri: string = ''; //=https%3A%2F%2Fonepass-sso-uat.cic.hk%2Foauth2%2Fv1%2Fauthorize%2Fcallback&
  response_type: string = ''; //=code&
  display: string = ''; //=page&
  scope: string = ''; //=email+openid+profile

  showModal: boolean = false;
  showPwModal: boolean = false;

  @Select(STATE_TOKEN) appState$!: Observable<StateModel>;

  @ViewChild('forgotPasswordForm')
  forgotPasswordForm?: FormForgotPasswordComponent;

  constructor(
    private router: Router,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private store: Store,
    private supportService: SupportService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private selfFactorService: SelfFactorService,
  ) {}

  async ngOnInit() {
    // const user = await this.oktaAuth.getUser();
    // this.user = JSON.stringify(user, null, 4);
    // this.translateService.setDefaultLang('zh-Hant');
    this.translateService.addLangs(['en', 'zh-Hant']);

    // Check for 'language' cookie and set language if present
    const getCookie = (): string | undefined => {
      const match = document.cookie.match(new RegExp('(^| )language=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : undefined;
    };
    const lang = getCookie();
    if (lang) {
      this.translate.use(lang);
      this.store.dispatch(new SetLanguage(lang));
    }

    this.store.dispatch(new ClearEverything());
  }

  onForgotPassword = async (payload: {
    account: string;
    validateFactor: string;
    appId?: string | null;
  }) => {
    this.formValues = payload;

    try {
      await this.proceedWith2fa(
        payload.account,
        payload.validateFactor,
        payload.appId,
      );
    } catch (e: any) {
      console.log(e);
      const errorResponse = e.error as ApiResponse<any>;

      if (errorResponse) {
        if (!errorResponse.success && errorResponse.errorMessage) {
          this.toastr.error(this.translate.instant(errorResponse.errorMessage));
        } else {
          this.toastr.error(this.translate.instant('account_locked_out_retry_later'));
        }
      }
    } finally {
      this.forgotPasswordForm!.isLoading = false;
    }
  };

  onForgotPasswordRedirect = async () => {};

  onSigninException = async (e: any) => {
    this.forgotPasswordForm!.isLoading = false;
    if (e as AuthApiError) {
      if (e.errorCauses.length > 0) {
        this.toastr.error(e.errorCauses[0].errorSummary);
      } else {
        this.toastr.error(e.errorSummary);
      }
    }
  };

  async proceedWith2fa(
    account: string,
    validateFactor: string,
    appId?: string | null,
  ) {
    let result = await this.selfFactorService.send2FaVerifyId(
      account,
      validateFactor,
      appId
    ) as any;
    this.store.dispatch(new ClearEnrollResponses());
    this.store.dispatch(new SetTempUserId(result.item1));
    if(result.item2.factorType === 'sms') {
      this.store.dispatch(new SmsEnrollResponse(result.item2));
    } else if (result.item2.factorType === 'email') {
      this.store.dispatch(new EmailEnrollResponse(result.item2));
    }
    this.router.navigate(['/forgot-password-validate']);
    // this.oktaAuth.session.setCookieAndRedirect((await firstValueFrom(this.appState$)).sessionToken, window.location.protocol + "//" + window.location.host + '/login-validate'); // Sets a cookie on redirect
  }

  onRegisterClick() {
    // this.choose2fa.requestPrompt(undefined, undefined);
    // this.router.navigate(['register']);
    this.showModal = true;
  }

  onForgotPasswordClick() {
    this.showPwModal = true;
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  togglePwModal() {
    this.showPwModal = !this.showPwModal;
  }

  onBackToLoginClick = () => {
    // this.router.navigate(['/portallogin']);
    window.close();
  };

  onCancel2fa = async () => {
    if (this.forgotPasswordForm) this.forgotPasswordForm.isLoading = false;
  };
}
